import { memo } from "react";
import MCQAnswer from "./MCQAnswer";
import DescriptiveTypingAnswer from "./DescriptiveTypingAnswer";
import DescriptiveUploadPDF from "./DescriptiveUploadPDF";

const AnswerSection = memo(function AnswerSection({
  type,
  handleChange,
  handleTypingChange,
  selectedValue,
  options,
  isMock,
  answerScrollRef,
  editorInstanceRef,
  currentSrNo,
  uploadType,
  allowUpload,
  uploadState,
  onInlineFileSelect,
  onInlineDelete,
  onInlineView,
  onInlineRetry,
  disabled,
}) {
  if (!type) return null;

  if (type === "MCQ") {
    return (
      <MCQAnswer
        selectedValue={selectedValue}
        handleChange={handleChange}
        options={options}
        isMock={isMock}
        answerScrollRef={answerScrollRef}
      />
    );
  }

  if (type === "DESCRIPTIVE_TYPING") {
    return (
      <DescriptiveTypingAnswer
        selectedValue={selectedValue}
        handleTypingChange={handleTypingChange}
        editorInstanceRef={editorInstanceRef}
        currentSrNo={currentSrNo}
      />
    );
  }

  if (type === "DESCRIPTIVE_UPLOAD") {
    if (uploadType === "END_EXAM_UPLOAD") {
      return (
        <p style={{marginTop: "10px", fontWeight: "bold" , color: "grey"}}>
          Write your answer on paper, clearly label it, scan or photograph it, and upload it.
        </p>
      );
    }

    if (allowUpload !== true || uploadType !== "INLINE_UPLOAD") return null;
    return (
      <DescriptiveUploadPDF
        currentSrNo={currentSrNo}
        uploadState={uploadState}
        onFileSelect={onInlineFileSelect}
        onDelete={onInlineDelete}
        onView={onInlineView}
        onRetry={onInlineRetry}
        disabled={disabled}
      />
    );
  }

  return null;
});

export default AnswerSection;